module.exports = __webpack_public_path__ + "img/chain_sale03.5df17390.png";